<template>
  <section id="discount" class="bg-gray">
  <div class="container">
    <div class="cart-row controls without-discount" v-if="!hasDiscount">
      <input type="text" v-model="code">
      <button class="btn mint small" @click="add()">Nalicz rabat</button>
    </div>

    <div class="cart-row controls with-discount" v-if="hasDiscount">
      <div class="delivery-amount-label">Naliczony rabat</div>
      <div class="delivery-amount" v-html="getPrice(discountValue)"></div>
      <div class='item-remove' v-on:click="remove()">
        <svg width="1.09375vw" height="1.09375vw" viewBox="0 0 21 21" enable-background="new 0 0 21 21" xml:space="preserve">
          <polygon points="7.718,-0.002 7.51,1.391 3.364,0.771 3.078,2.689 17.711,4.876 17.999,2.958 13.76,2.325 13.968,0.932 7.718,-0.002 "/>
          <path d="M17.762,6.833l0.002-1.22H3.001l0.002,1.22h1.062v13.484c0,0-0.017,0.641,0.583,0.681h11.47 c0.6-0.04,0.582-0.681,0.582-0.681V6.833H17.762z M7.192,18.218c0,0.334-0.271,0.604-0.605,0.604s-0.604-0.271-0.604-0.604V8.182 c0-0.334,0.271-0.605,0.604-0.605s0.605,0.271,0.605,0.605V18.218z M9.811,18.218c0,0.334-0.271,0.604-0.605,0.604 c-0.334,0-0.604-0.271-0.604-0.604V8.182c0-0.334,0.271-0.605,0.604-0.605c0.334,0,0.605,0.271,0.605,0.605V18.218z M12.351,18.218 c0,0.334-0.271,0.604-0.605,0.604s-0.605-0.271-0.605-0.604V8.182c0-0.334,0.271-0.605,0.605-0.605s0.605,0.271,0.605,0.605V18.218z M14.849,18.218c0,0.334-0.271,0.604-0.604,0.604s-0.604-0.271-0.604-0.604V8.182c0-0.334,0.271-0.605,0.604-0.605 s0.604,0.271,0.604,0.605V18.218z"/>
        </svg>
      </div>
    </div>
  </div>
  </section>
</template>

<script>

  import store from "./../../store/index"

  export default {

    name: "Discount",
    computed: {
      hasDiscount() {
        if (null !== this.discount) {
          if (typeof this.discount === 'object') {
            if ('id' in this.discount) {

              return true;
            }
          }
        }
        return false;
      },
      discountValue() {
        return store.getters.discountValue;
      },
      orderId() {
        return store.getters.orderId;
      },
      discount() {
        return store.getters.discount;
      }
    },
    data() {
      return {
        code: "",
      }
    },
    methods: {
      add() {
        store.dispatch('setDiscountCode', {code: this.code});
      },
      remove() {
        store.dispatch('removeDiscount');
      },
      getPrice(price) {
        return this.$options.filters.full_price(price)
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Cart/Discount.vue